export { default } from './ShoppingCartProductRow';
